import { Component, Input, Output, EventEmitter, OnChanges,SimpleChanges} from '@angular/core';

@Component({
  selector: 'app-account-relation-access',
  templateUrl: './account-relation-access.component.html',
  styleUrls: ['./account-relation-access.component.scss']
})
export class AccountRelationAccessComponent implements OnChanges {

  @Input() displayRelationship: boolean = false;
  @Input() relationship = [];
  @Output() onClose = new EventEmitter();
  @Output() onSave = new EventEmitter();
  hasAccessAll: boolean = false;

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.relationship?.currentValue) {
       this.changeAllAccess();
    }
  }

  changeAllAccess(){
    for(let s of this.relationship){
        if(!s.hasAccess){
            this.hasAccessAll = false;
            break;
        } else {
            this.hasAccessAll = true;
        }
    }
  }

  checkAllAccess() {
    if(this.hasAccessAll){
      for(let s of this.relationship){
        s.hasAccess = true;
      }
    }else{
      for(let s of this.relationship){
        s.hasAccess = false;
      }
    }
  }

  closeDialog(){
    this.onClose.emit();
  }

  saveRelationship(): void {
    const childAccounts: number[] = this.relationship
        .filter(relation => relation.hasAccess)
        .map(relation => relation.childAccountId);
     this.onSave.emit(childAccounts);
}

}
